import React from 'react';
import { MDBContainer, MDBDataTable, MDBRow, MDBCol, MDBBtn, MDBSelect, MDBIcon, MDBCard, MDBCardBody } from 'mdbreact';
import DataLayer from '../Utilities/DataLayer';
import Header from './ComponentFragments/Header';
import Formatter from '../Utilities/Formatter';
import GoalChart from './ComponentFragments/GoalChart';

export default class Goals extends React.Component {

    constructor(props) {
        super(props);
        this.props.loaderOn();
        this.state = {
            yearData: [],
            segmentData: [],
            goalsData: [],
            weeksPercentages: [],
            weeklySales: [],
            weeklyGoalsData: [],
            currSegment: 0,
            selectedYear: 0,
            selectedSegment: 0,
            salesGoal: 0,
            selectedSegSales: 0,
            goalsHidden: true,
            goalData: [],
            fastStartGoal: 0,
            fastStartShortFall: 0,
            fastStartOver: 0
        }
        this.formatter = new Formatter();
        this.handleYearSelectChange = this.handleYearSelectChange.bind(this);
        this.handleSegmentSelectChange = this.handleSegmentSelectChange.bind(this);
        this.handleGoalSelectChange = this.handleGoalSelectChange.bind(this);
        this.getGoalsData = this.getGoalsData.bind(this);
    }

    handleGoalSelectChange(selected) {
        this.setState({
            selectedGoalId: selected[0]
        });
    }

    async loadSegmentsForYear(year) {
        this.props.loaderOn();
        var dl = new DataLayer();
        let result = await dl.Get('/common/getsegmentsforyear?yearId=' + year, 200);
        let segData = [];
        result.data.forEach((segment) => segData.push(
            { checked: segment.periodId == this.state.currSegment ? true : false, value: segment.periodId, text: segment.description }
        ));


        this.setState({
            segmentData: segData,
            selectedSegment: segData[0].value,


        })

        this.props.loaderOff();
    }


    handleYearSelectChange(selected) {
        this.setState({
            selectedYear: selected[0]
        });
        this.loadSegmentsForYear(selected[0])
    }

    handleSegmentSelectChange(selected) {
        this.setState({
            selectedSegment: selected[0]
        });
    }



    async componentWillMount() {
        this.props.loaderOn();
        var dl = new DataLayer();
        let result = await dl.Get('/common/getyears', 200);
        let currSeg = await dl.Get('/common/getCurrSegment', 200);
        let goals = await dl.Get('/common/getGoals', 200);
        let yearsData = [];
        let goalsData = [];

        result.data[0].forEach((year) => yearsData.push({ checked: false, value: year.value, text: year.label }));
        yearsData[0].checked = true;

        goals.data.forEach((goal) => goalsData.push({ checked: false, value: goal.value, text: goal.label }));
        goalsData[0].checked = true;

        this.setState({
            yearData: yearsData,
            selectedYear: yearsData[0].value,
            currSegment: currSeg.data,
            goalData: goalsData
        })
        this.props.loaderOff();
    }

    async getGoalsData() {
        this.props.loaderOn();
        var dl = new DataLayer();
        let fastStartGoal = await dl.Get('/demonstrator/getFastStartGoal?segmentId=' + this.state.selectedSegment, 200);
        let result = await dl.Get('/demonstrator/getgoals?segmentId=' + this.state.selectedSegment, 200);
        let weeklySales = await dl.Get('/demonstrator/geTeamWeeklySales?segmentId=' + this.state.selectedSegment, 200);
        let weekPercentage = await dl.Get('/demonstrator/getWeeksPercentage?segmentId=' + this.state.selectedSegment, 200);

        var sGoal = 0;
        var leadsGoal = 0;
        var activeRecruitsGoal = 0;
        var promoteInsGoal = 0;
        var uniqueSellersGoal = 0;
        var activeSFGoal = 0;
        result.data.forEach(goal => {
            if (goal.goalId == 1) {
                sGoal = goal.goalAmount; //sales
            }
            if (goal.goalId == 2) { //Leads
                leadsGoal = goal.goalAmount;
            }
            if (goal.goalId == 3) { //Active Recruits
                activeRecruitsGoal = goal.goalAmount;
            }
            if (goal.goalId == 4) { //Promote -ins
                promoteInsGoal = goal.goalAmount;
            }
            if (goal.goalId == 5) { // Unique Sellers
                uniqueSellersGoal = goal.goalAmount;
            }
            if (goal.goalId == 6) { //Active SF
                activeSFGoal = goal.goalAmount;
            }
        })

        let weekGoals = [];
        let goalTitle = ""
        let goalValue = 0;
        let progress = 0;
        let goalPercentage = "50"
        let color = "#8355c9"
        let currSales = 0;
        weekPercentage.data.forEach(weekPerc => {
            if (weekPerc.goalId == 1) {
                weekGoals.push({ weekId: weekPerc.weekId, percentage: weekPerc.percentage, goalId: weekPerc.goalId, goalTitle: "Sales Goal Week " + weekPerc.weekId + " @" + weekPerc.percentage + "% of Total Goal", goalValue: 0, progress: 0, goalPercentage: 0, color: color })
            }
            if (weekPerc.goalId == 2) {
                weekGoals.push({ weekId: weekPerc.weekId, percentage: weekPerc.percentage, goalId: weekPerc.goalId, goalTitle: "Leads Goal Week " + weekPerc.weekId + " @" + weekPerc.percentage + "% of Total Goal", goalValue: 0, progress: 0, goalPercentage: 0, color: color })
            }
            if (weekPerc.goalId == 3) {
                weekGoals.push({ weekId: weekPerc.weekId, percentage: weekPerc.percentage, goalId: weekPerc.goalId, goalTitle: "Active Recruits Goal Week " + weekPerc.weekId + " @" + weekPerc.percentage + "% of Total Goal", goalValue: 0, progress: 0, goalPercentage: 0, color: color })
            }
            //if (weekPerc.goalId == 4) {
            //    weekGoals.push({ weekId: weekPerc.weekId, percentage: weekPerc.percentage, goalId: weekPerc.goalId, goalTitle: "Promote-in Goal Week " + weekPerc.weekId + " @" + weekPerc.percentage + "% of Total Goal", goalValue: 0, progress: 0, goalPercentage: 0, color: color })
            //}
            if (weekPerc.goalId == 5) {
                weekGoals.push({ weekId: weekPerc.weekId, percentage: weekPerc.percentage, goalId: weekPerc.goalId, goalTitle: "Unique Sellers Goal Week " + weekPerc.weekId + " @" + weekPerc.percentage + "% of Total Goal", goalValue: 0, progress: 0, goalPercentage: 0, color: color })
            }
            if (weekPerc.goalId == 6) {
                weekGoals.push({ weekId: weekPerc.weekId, percentage: weekPerc.percentage, goalId: weekPerc.goalId, goalTitle: "Active Salesforce Goal Week " + weekPerc.weekId + " @" + weekPerc.percentage + "% of Total Goal", goalValue: 0, progress: 0, goalPercentage: 0, color: color })
            }
        });

        weekGoals.forEach(weekGoal => {
            weeklySales.data.salesbyWeek.forEach(weekSale => {
                if (weekSale.weekId == weekGoal.weekId && weekGoal.goalId == 1) {
                    weekGoal.goalValue = sGoal * (weekGoal.percentage / 100);
                    weekGoal.progress = weekSale.recognition;
                    weekGoal.goalPercentage = (weekSale.recognition / weekGoal.goalValue) * 100
                }
            });
            weeklySales.data.leadsByWeek.forEach(weekLead => {
                if (weekLead.weekId == weekGoal.weekId && weekGoal.goalId == 2) {
                    weekGoal.goalValue = leadsGoal * (weekGoal.percentage / 100);
                    weekGoal.progress = weekLead.goalProgressAmount1;
                    weekGoal.goalPercentage = (weekLead.goalProgressAmount1 / weekGoal.goalValue) * 100

                }
            });
            weeklySales.data.activeRecruitsByWeek.forEach(weekAr => {
                if (weekAr.weekId == weekGoal.weekId && weekGoal.goalId == 3) {
                    weekGoal.goalValue = (activeRecruitsGoal * (weekGoal.percentage / 100)).toFixed(0) * 1;
                    weekGoal.progress = weekAr.goalProgressAmount1;
                    weekGoal.goalPercentage = (weekAr.goalProgressAmount1 / weekGoal.goalValue) * 100
                }
            });
            //weeklySales.data.promoteInsByWeek.forEach(weekPI => {
            //    if (weekPI.weekId == weekGoal.weekId && weekGoal.goalId == 4) {
            //        weekGoal.goalValue = (promoteInsGoal * (weekGoal.percentage / 100)).toFixed(0) * 1;
            //        weekGoal.progress = weekPI.goalProgressAmount1;
            //        weekGoal.goalPercentage = (weekPI.goalProgressAmount1 / weekGoal.goalValue) * 100
            //    }
            //});
            weeklySales.data.uniqueSellersByWeek.forEach(weekUs => {
                if (weekUs.weekId == weekGoal.weekId && weekGoal.goalId == 5) {
                    weekGoal.goalValue = (uniqueSellersGoal * (weekGoal.percentage / 100)).toFixed(0) * 1;
                    weekGoal.progress = weekUs.goalProgressAmount1;
                    weekGoal.goalPercentage = (weekUs.goalProgressAmount1 / weekGoal.goalValue) * 100
                }
            });
            weeklySales.data.activeSalesForceByWeek.forEach(weekAs => {
                if (weekAs.weekId == weekGoal.weekId && weekGoal.goalId == 6) {
                    weekGoal.goalValue = (activeSFGoal * (weekGoal.percentage / 100)).toFixed(0) * 1;
                    weekGoal.progress = weekAs.goalProgressAmount1;
                    weekGoal.goalPercentage = (weekAs.goalProgressAmount1 / weekGoal.goalValue) * 100
                }
            });
        })

        weekGoals.sort((a, b) => a.goalId > b.goalId ? 1 : -1);

        result.data.forEach(goal => {
            if (goal.goalId == 1) {
                currSales = goal.currentAmount;
            }
        });

        let shortFall = 0;
        let over = 0;
        if (fastStartGoal.data.dreamGoalAmount > 0) {
            shortFall = fastStartGoal.data.dreamGoalAmount - currSales <= 0 ? 0 : this.formatter.formatCurrency(fastStartGoal.data.dreamGoalAmount - currSales);
            over = fastStartGoal.data.dreamGoalAmount - currSales <= 0 ? this.formatter.formatCurrency((fastStartGoal.data.dreamGoalAmount - currSales) * - 1) : 0;
        }

        this.setState({
            goalsData: result.data,
            weeksPercentages: weekPercentage.data,
            salesGoal: sGoal,
            weeklySales: weeklySales.data,
            weeklyGoalsData: weekGoals,
            selectedSegSales: currSales,

            fastStartGoal: fastStartGoal.data.dreamGoalAmount,
            fastStartShortFall: shortFall,
            fastStartOver: over,
            goalsHidden: false
        })
        this.props.loaderOff();

    }

    render() {
        return (
            <div>
                <Header headerText='Goals'
                    subHeaderText="(Click Go to load goals for selected segment.)"
                    hideSearch='true'
                />
                <MDBCard>
                    <MDBCardBody>
                        <MDBRow>
                            <MDBCol md="6">
                                <MDBContainer>
                                    <MDBRow className="mt-3">
                                        <MDBCol>
                                            <MDBSelect label="Year..."
                                                options={this.state.yearData}
                                                selected="Filter"
                                                getValue={this.handleYearSelectChange}
                                                required
                                            />
                                        </MDBCol>

                                    </MDBRow>
                                    <MDBRow className="mt-3">
                                        <MDBCol>
                                            <MDBSelect label="Segment..."
                                                options={this.state.segmentData}
                                                selected="Filter"
                                                getValue={this.handleSegmentSelectChange}
                                                required
                                            />
                                        </MDBCol>
                                    </MDBRow>
                                    <MDBRow>
                                        <MDBCol>
                                            <MDBBtn onClick={this.getGoalsData}>Go</MDBBtn>
                                        </MDBCol>
                                    </MDBRow>
                                </MDBContainer>
                            </MDBCol>
                            <MDBCol md="6">
                                <MDBRow>
                                    <GoalChart
                                        goalTitle="Fast Start Goal"
                                        goalValue={this.formatter.formatCurrency(this.state.fastStartGoal)}
                                        progress={this.formatter.formatCurrency(this.state.selectedSegSales)}
                                        goalPercentage={this.state.fastStartGoal > 0 ? ((this.state.selectedSegSales / this.state.fastStartGoal) * 100).toFixed(0) : 0}
                                        color="#b266e8"
                                        setCols="0"
                                        shortFall={this.state.fastStartShortFall}
                                        over={this.state.fastStartOver}
                                    />
                                </MDBRow>


                            </MDBCol>

                        </MDBRow>
                    </MDBCardBody>
                </MDBCard>
                <br />

                <div hidden={this.state.goalsHidden}>
                    <MDBCard>
                        <MDBCardBody>
                            <MDBRow className="mt-3">
                                <MDBCol md="6">
                                    <MDBSelect label="Goal..."
                                        options={this.state.goalData}
                                        selected="Filter"
                                        getValue={this.handleGoalSelectChange}
                                        required
                                    />
                                </MDBCol>
                            </MDBRow>
                            <MDBRow>
                                {
                                    this.state.goalsData.map((goal) => {
                                        if (this.state.selectedGoalId == goal.goalId) {
                                            let goalPercentage = goal.goalAmount > 0 ? (goal.currentAmount / goal.goalAmount) * 100 : 100;
                                            let goalAmount = goal.goalAmount
                                            let currentAmount = goal.currentAmount;
                                            let shortFall = goalAmount - currentAmount <= 0 ? 0 : goalAmount - currentAmount;
                                            let over = goalAmount - currentAmount <= 0 ? (goalAmount - currentAmount) * - 1 : 0;
                                            if (goal.goalId == 1) {
                                                goalAmount = this.formatter.formatCurrency(goalAmount);
                                                currentAmount = this.formatter.formatCurrency(currentAmount);
                                                shortFall = this.formatter.formatCurrency(shortFall);
                                                over = this.formatter.formatCurrency(over);
                                            } else {
                                                goalAmount = goalAmount.toFixed(0);
                                                shortFall = shortFall.toFixed(0);
                                                over = over.toFixed(0);
                                            }
                                            let color = "#b304d6";
                                            switch (goal.goalId) {
                                                case 2:
                                                    color = "#de3162";
                                                    break;
                                                case 3:
                                                    color = "#8355c9";
                                                    break;
                                                case 4:
                                                    color = "#e0a928";
                                                    break;
                                                case 5:
                                                    color = "#f763e6";
                                                    break;
                                                case 6:
                                                    color = "#b266e8";
                                                    break;
                                                default:
                                                    color = "#04d67f";
                                            }
                                            return (


                                                <GoalChart
                                                    goalTitle={goal.goalName}
                                                    goalValue={goalAmount}
                                                    progress={currentAmount}
                                                    goalPercentage={goalPercentage.toFixed(0)}
                                                    color={color}
                                                    setCols="1"
                                                    shortFall={shortFall}
                                                    over={over}
                                                />



                                            )
                                        }

                                    })
                                }

                            </MDBRow>
                            <MDBRow>
                                {
                                    this.state.weeklyGoalsData.map(weekGoal => {
                                        if (this.state.selectedGoalId == weekGoal.goalId) {
                                            let goalAmount = weekGoal.goalValue
                                            let currentAmount = weekGoal.progress;
                                            let shortFall = goalAmount - currentAmount <= 0 ? 0 : goalAmount - currentAmount;
                                            let over = goalAmount - currentAmount <= 0 ? (goalAmount - currentAmount) * - 1 : 0;
                                            return (
                                                <GoalChart
                                                    goalTitle={weekGoal.goalTitle}
                                                    goalValue={weekGoal.goalId == 1 ? this.formatter.formatCurrency(weekGoal.goalValue) : weekGoal.goalValue.toFixed(0)}
                                                    progress={weekGoal.goalId == 1 ? this.formatter.formatCurrency(weekGoal.progress) : weekGoal.progress.toFixed(0)}
                                                    goalPercentage={weekGoal.goalPercentage.toFixed(0)}
                                                    color={weekGoal.color}
                                                    setCols="1"
                                                    shortFall={weekGoal.goalId == 1 ? this.formatter.formatCurrency(shortFall) : shortFall.toFixed(0)}
                                                    over={weekGoal.goalId == 1 ? this.formatter.formatCurrency(over) : over.toFixed(0)}
                                                />
                                            )
                                        }
                                    })
                                }
                            </MDBRow>
                        </MDBCardBody>
                    </MDBCard>
                </div>
            </div>
        );
    }


}
